import { mapState } from 'vuex';

export default {
    name: 'wai-searchsymptoms',
    model : {
        prop : 'symptoms',
        event : 'change'
    },
    props: {
        symptoms : Array,
        colors : Object
    },

    data : function(){

        return {
            loading : false,
            coeffvec : true
        }

    },

    computed: mapState({
        auth : state => state.auth,

        _colors : function(){
            var cs = {}

            _.each(this.colors, function(c, i){
                cs[c] = i
            })


            return cs
        }
    }),

    watch : {
        coeffvec : function(){
            this.search()
        }
    },

    methods : {
        remove : function(cui){

            if(this.loading) return

            this.$emit('change', _.filter(this.symptoms, function(s) {
                return s.CUI != cui;
            }))

            var s = this.search

            setTimeout(function(){
                s()
            }, 200)
            

        },

        search : function(){
            if(!this.symptoms.length) return

            this.loading = true

            var codes = _.map(this.symptoms, function(s){
                return s.CUI.toLowerCase()
            })

            this.$root.api.wai.py.allresdcorona({

                codes : JSON.stringify(codes),
                coeffvec : this.coeffvec

            }).then(results => {

                if (this.loading){
                    this.loading = false

                    /*_.each(results.data, function(d, i){

                        results.data[i] = _.sortBy(d, function(d){
                            return -Number(d[p])
                        })

                    })*/
                    
                    this.$emit('result', results.data)
                }
                else{
                    
                }

                

            }).catch(error => {

                console.log(error)

                if (this.loading){
                    this.loading = false
                }
                else{

                }

            })
        }
    },
}